import * as React from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { IRiderObject, IStateMetadata } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import AddCardForm from '../../common/AddCardForm'
import Modal from '../../../ui/Modal'

interface IAddCardFormModal {
  metadata: IStateMetadata
  rider: IRiderObject
  onClose: () => void
  addRiderPaymentSource: (stripeToken: string, riderId: string) => Promise<any>
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
  updateDefaultPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
}

class AddCardFormModal extends React.Component<IAddCardFormModal> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { rider } = this.props

    if (!rider) {
      return null
    }

    const cardFormProps = {
      rider,
      addRiderPaymentSource: this.props.addRiderPaymentSource,
      metadata: this.props.metadata
    }
    const key =
      process.env.REACT_APP_ENV === 'production'
        ? process.env.REACT_APP_STRIPE_KEY_PROD || ''
        : process.env.REACT_APP_STRIPE_KEY_TEST || ''
    console.log('using stripe key: ', key)
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
              {UIMessages.common.addPaymentMethod}
            </span>
            <div className='mt1 border-top'>
              <StripeProvider apiKey={key}>
                <Elements>
                  <AddCardForm {...cardFormProps} onCancel={this.handleCancelClick} />
                </Elements>
              </StripeProvider>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default AddCardFormModal



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/AddCardFormModal.tsx